<script setup lang="ts">
import type { Typography } from '@/types/Typography';

const { element = 'p', type = 'body-1' } = defineProps<{
  element?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span' | 'div';
  type?: Typography;
}>();

const classes = computed(() => {
  // append your typography css here
  return [`font-${type}`];
});
</script>

<template>
  <component :is="element" data-testid="typography" :class="classes">
    <slot></slot>
  </component>
</template>

<style></style>
